module.exports = __webpack_public_path__ + "069d7892eab58611a88b6ec3f5466c66.svg";